<template>
  <div class="good-info">
    <div class="good-basic container">
      <div class="good-basic-left">
        <ISwiper :imgList="detailInfo.imgList">
          <!-- 拼团商品 -->
          <GroupTemplate v-if="goodType == 2" key="0" :detailInfo="detailInfo"/>
          <!-- 秒杀商品 -->
          <SeckillTemplate v-if="goodType == 1" key="1" :detailInfo="detailInfo"/>
        </ISwiper>
      </div>
      <div class="good-basic-right">
        <div class="spu-name-content">
          <div class="spu-name sl-ellipsis">{{ detailInfo.spuName }}</div>
          <div class="spu-name-en sl-ellipsis">{{ detailInfo.spuNameEn }}</div>
          <div class="shop-cart-box">
            <ShopCardIcon :value="basketCount"/>
          </div>
        </div>
        <div class="spu-price-content fl-align-center">
          <!-- 积分商品 -->
          <div class="spu-price" v-if="goodType == 4">
            <template v-if="showPrice == null">
              <template v-if="detailInfo.integralPrice - 0">
                <span>￥</span>
                <span>{{ detailInfo.integralPrice }}</span>
              </template>
              <span v-if="detailInfo.integralPrice - 0 && detailInfo.integralValue - 0">+</span>
              <span v-if="detailInfo.integralValue - 0">{{ detailInfo.integralValue }}积分</span>
            </template>
            <template v-else>
              <span>{{ showPrice }}</span>
            </template>
          </div>
          <template v-else>
            <template v-if="showPrice == null">
              <span class="spu-price">￥{{ detailInfo.price }}</span>
            </template>
            <template v-else>
              <span class="spu-price">{{ showPrice }}</span>
            </template>
            <div class="spu-oprice">￥{{ detailInfo.oprice }}</div>
          </template>
        </div>
        <div class="coupons-area-box" v-if="couponList.length && goodType == 0">
          <p class="coupons-area-t">优惠券 Coupons</p>
          <div class="coupons-area">
            <div class="coupon-item" v-for="item in couponList" :key="item.id" v-if="item.formatName">
              <span>{{ item.formatName }}</span>
              <span>{{ item.formatNameEn }}</span>
            </div>
            <el-button class="get-coupon fl-center" @click="getCoupon">领券 Coupon collection</el-button>
          </div>
        </div>
        <specSelect
            :goodType="goodType"
            :skuList="detailInfo.skuList"
            :detailInfo="detailInfo"
            :propsList="propsList"
            :skuData="skuData"
            :shareGroupImg="shareGroupImg"
            @submitAction="submitAction"
            @postShowPrice="postShowPrice"
        />
      </div>
    </div>
    <div v-if="detailInfo.posterDistributeSwitch == 1 && shareImg" class="distribution-shared container">
      <p style="margin-right:20px">分销可得佣金，需在小程序端分享 Distribution Commission, to be shared on the applet side</p>
      <el-popover title="" width="300" trigger="hover">
        <el-image :src="shareImg"></el-image>
        <div class="qrcode" slot="reference">
          <el-image class="shareImg" :src="shareImg"/>
        </div>
      </el-popover>
    </div>

    <div class="good-detail container">
      <div class="good-detail-title">
        <span>商品详情</span>
        <span>Product Description</span>
        <div class="good-detail-validity" v-if="detailInfo.rangeSwitch==1">
          <span>使用有效期</span>
          <span>（Term of validity）：</span>
          <span>{{ detailInfo.rangeStartTime }}至{{ detailInfo.rangeEndTime }}</span>
        </div>
      </div>

      <div class="good-editor" v-html="detailInfo.details"></div>
    </div>
    <GetCouponsDialog :visible.sync="visible" :couponList="allCouponList"/>
  </div>
</template>

<script>
import ISwiper from "@/components/base/ISwiper.vue";
import ShopCardIcon from "@/components/base/ShopCardIcon.vue";
import specSelect from "@/components/specSelect/Index.vue";
import GetCouponsDialog from "@/components/base/GetCouponsDialog.vue";
import GroupTemplate from "./components/GroupTemplate";
import SeckillTemplate from "./components/SeckillTemplate.vue";
import moment from "moment";

export default {
  name: "GoodInfo",
  data() {
    return {
      detailInfo: {},
      couponList: [], //优惠券列表
      allCouponList: [], //全量优惠券列表
      goodType: 0, //0普通商品 1秒杀商品 2拼团商品 3外卖商品 4积分商品 5酒店
      id: "", //商品id,
      activityId: "", //活动id
      propsList: [],
      skuData: {},
      visible: false, //是否显示优惠券弹窗
      shareGroupImg: "",
      showPrice: null,
      basketCount: 0,
      shareImg: "",
    };
  },
  props: {},
  computed: {},
  components: {ISwiper, specSelect, ShopCardIcon, GetCouponsDialog, GroupTemplate, SeckillTemplate},
  async mounted() {
    this.goodType = this.$route.query.type;
    this.id = this.$route.query.id;
    this.activityId = this.$route.query.activityId;
    if (this.goodType == 1 || this.goodType == 2) {
      await this.getActivity(); //获取活动  0:拼团活动 1:秒杀活动
    } else {
      await this.getGoodInfo(); //商品详情
    }
    this.getListForSpu();
    this.getBasketCount();
  },
  methods: {
    async getGoodInfo() {
      const params = {
        id: this.id,
      };
      try {
        let {data} = await this.$api.getGoodInfo(params);
        let detailInfo = data || {};
        detailInfo.imgList = (detailInfo.images || "").split(",");
        let topImg = "";
        if (detailInfo.displayAtEndSwitch == 1) {
          for (let i = 0; i < detailInfo.imgList.length; i++) {
            topImg += `<img src="${detailInfo.imgList[i]}"/>`;
          }
        }
        detailInfo.details = ((detailInfo.details || "") + topImg).replace(/img/g, 'img class="descClauseImg"');
        if (Number(detailInfo.oprice) && Number(detailInfo.oprice) != Number(detailInfo.price)) {
          detailInfo.showOprice = true;
        }
        this.detailInfo = detailInfo;
        let specInfo = JSON.parse(this.detailInfo.specInfo);
        this.propsList = this.handleSpecFormat(specInfo);
        this.skuData = this.handleSkuDataFormat(this.detailInfo.skuList);
        if (detailInfo.posterDistributeSwitch == 1) {
          this.getQrCode(detailInfo);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getQrCode(detail) {
      const params = {
        page: "implant/goodDetail/index",
        spuId: detail.id,
      };
      try {
        let {data} = await this.$api.getBuildCode(params);
        this.shareImg = data ? data.codeUrl : "";
      } catch (error) {
        console.log(error);
      }
    },

    //获取购物车数量
    async getBasketCount() {
      try {
        let {data} = await this.$api.getBasketCount();
        this.basketCount = data || 0;
      } catch (error) {
        console.log(error);
      }
    },
    async postShowPrice(val) {
      this.showPrice = val;
    },
    //获取活动
    async getActivity() {
      return new Promise(async (resolve, reject) => {
        const params = {
          activityType: this.goodType == 1 ? 1 : 0,
          id: this.activityId,
        };
        const {data} = await this.$api.getActivity(params);
        let detailInfo = data;
        detailInfo.imgList = (data.spu.images || "").split(",");
        detailInfo.specInfo = detailInfo.spu.specInfo;
        detailInfo.multiSpecSwitch = detailInfo.spu.multiSpecSwitch;
        let topImg = data.spu.displayAtEndSwitch == 1 ? `<img src="${data.spu.coverImage}"/>` : "";
        detailInfo.details = (topImg + (data.spu.details || "")).replace(/img/g, 'img class="descClauseImg"');
        let startTime = moment(detailInfo.startTime).valueOf();
        let endTime = moment(detailInfo.endTime).valueOf();
        // let nowTime = await getCurrentTime();
        let nowTime = Date().valueOf();
        if (detailInfo.status == 1) {
          this.time = endTime - nowTime;
          detailInfo.price = detailInfo.salePrice;
        } else if (detailInfo.status == 0) {
          detailInfo.price = detailInfo.spu.price;
          detailInfo.oprice = detailInfo.spu.oprice;
          detailInfo.startTimeFormate = moment(detailInfo.startTime).format("MM月DD日 HH:mm");
          detailInfo.skuList = detailInfo.spu.skuList;
        }
        if (Number(detailInfo.oprice) && Number(detailInfo.oprice) != Number(detailInfo.price)) {
          detailInfo.showOprice = true;
        }
        detailInfo.rangeStartTime = detailInfo.spu?.rangeStartTime
        detailInfo.rangeEndTime = detailInfo.spu?.rangeEndTime
        detailInfo.rangeSwitch = detailInfo.spu?.rangeSwitch
        this.detailInfo = detailInfo;
        this.id = detailInfo.spu.id;
        let specInfo = JSON.parse(this.detailInfo.specInfo);
        this.propsList = this.handleSpecFormat(specInfo);
        this.detailInfo.skuList = this.detailInfo.skuList.map((item) => {
          item.id = item.skuId;
          return item;
        });
        this.skuData = this.handleSkuDataFormat(this.detailInfo.skuList);
        if (this.goodType == 2) {
          this.handleGroupImg();
        }
        resolve();
      });
    },
    //处理拼团
    async handleGroupImg() {
      const params = {
        page: `implant/goodDetail/index`,
        scene: `isFrom=pc&type=2&activityId=${this.detailInfo.id}`,
      };
      try {
        let {data} = await this.$api.getQrCode(params);
        this.shareGroupImg = data;
      } catch (error) {
        console.log(error);
      }
    },
    handleSpecFormat(list) {
      let propsList = (list || []).map((item) => {
        let standardInfoList = (item.specValues || []).map((subItem) => {
          return {
            standardName: subItem,
            isSelect: 0,
          };
        });
        return {
          standardListName: item.specName,
          standardListId: item.specId,
          standardInfoList: standardInfoList,
        };
      });
      return propsList;
    },
    handleSkuDataFormat(list) {
      let skuData = {};
      list = list.filter((item) => item.stock > 0);
      (list || []).map((item) => {
        skuData[item.specValue] = {
          price: item.price,
          stocksNumber: item.stock,
          productId: item.id,
          integralPrice: item.integralPrice,
          integralValue: item.integralValue,
        };
      });
      // console.log(skuData);
      return skuData;
    },
    submitAction({type, takeWay, checkedGood}) {
      //takeWay 0 自提 1 物流
      //type: 0 积分兑换 1 秒杀 2 加购
      if (type == 1 && this.detailInfo.spu.status == 2) {
        this.$alert("该商品已下架", "提示", {})
            .then(() => {
              this.$router.replace("/e-shop");
            })
            .catch(() => {
            });
        return;
      }
      if (type == 0 || type == 1) {
        let goodsData = {
          emsStoreInfoList: [],
          takeStoreInfoList: [],
        };
        if (takeWay == 1) {
          goodsData.emsStoreInfoList = [checkedGood];
        } else {
          goodsData.takeStoreInfoList = [checkedGood];
        }
        let obj = {
          goodsData,
          orderType: this.goodType,
        };
        this.$router.push(`/e-shop/confirm-order?obj=${JSON.stringify(obj)}`);
      } else {
        this.addBasket(checkedGood.qty, checkedGood.skuId, takeWay);
      }
    },
    async addBasket(qty, skuId, takeWay) {
      let params = {
        checked: 1,
        qty: qty,
        skuId: skuId,
        takeType: takeWay,
      };
      try {
        let {data} = await this.$api.addBasket(params);
        this.$message.success("成功加入购物车！");
        await this.getBasketCount();
      } catch (error) {
        console.log(error);
      }
    },
    //获取商品优惠券列表
    async getListForSpu() {
      const params = {
        spuId: this.id,
        page: 1,
        pageSize: 100,
      };
      try {
        let {
          data: {list},
        } = await this.$api.getListForHotem(params);
        const couponList = list.slice(0, 2)
        this.couponList = couponList.map((currentValue) => {
          return this.fnFormatName(currentValue)
        })
        this.allCouponList = list;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 格式化优惠券名称
     * @param data
     */
    fnFormatName(data) {
      //couponType 券的类型 0-现金券、1-折扣券、2-礼品券、3-充值券
      //couponValue 折扣/券面值
      //writeOffConditionSwitch 门槛 ，1-有门槛、0-无门槛
      //writeOffConditionPrice 有门槛，满享
      //discountMaxAmount 最高抵扣
      const couponType = data.couponType
      let couponValue = data.couponValue
      const writeOffConditionSwitch = data.writeOffConditionSwitch
      const writeOffConditionPrice = data.writeOffConditionPrice
      const discountMaxAmount = data.discountMaxAmount
      let formatName = "";
      let formatNameEn = ""
      if (couponType == 0) {
        if (writeOffConditionSwitch == 0) {
          formatName = `¥${couponValue}`
          formatNameEn = `¥${couponValue}`
        } else {
          formatName = `￥${couponValue} (满 ￥${writeOffConditionPrice} 可用)`
          formatNameEn = `￥${couponValue} (payments over ￥${writeOffConditionPrice})`
        }
      }
      else if (couponType == 1) {
        if (typeof couponValue==="string")
          couponValue=+couponValue
        if (writeOffConditionSwitch == 0) {
          formatName = discountMaxAmount != null ? `${couponValue}折 ￥${discountMaxAmount}` : `${couponValue}折`
          formatNameEn = discountMaxAmount != null ? `${100-couponValue*10}% off ￥ ${discountMaxAmount} ` : `${100-couponValue*10}% off`

        } else {
          formatName = `${couponValue}折(满${writeOffConditionPrice}可用) `
          formatNameEn = ` ${100-couponValue*10}% off (payments over ¥${writeOffConditionPrice})`
        }
      }
      data.formatName = formatName
      data.formatNameEn = formatNameEn
      return data
    },
    getCoupon() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.good-basic {
  margin-top: 60px;
  display: flex;
  align-items: flex-start;

  .good-basic-left {
    flex: 0 0 auto;
  }

  .good-basic-right {
    padding-left: 50px;
  }

  .spu-name-content {
    flex: 1;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    position: relative;

    .spu-name,
    .spu-name-en {
      width: 500px;
    }

    .shop-cart-box {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .spu-price-content {
    margin-top: 40px;

    .spu-price {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .spu-oprice {
      font-size: 14px;
      font-weight: 400;
      text-decoration: line-through;
      color: #333333;
      margin-left: 18px;
    }
  }

  .coupons-area-box {
    .coupons-area-t {
      font-size: 14px;
      color: #333333;
      margin-top: 47px;
      margin-bottom: 19px;
    }

    .coupons-area {
      width: 100%;
      display: flex;
      overflow: hidden;
      height: 40px;

      .coupon-item {
        width: 170px;
        height: 40px;
        display: flex;
        margin-right: 20px;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        box-sizing: border-box;
        padding: 0 10px;
        background: url("~@/assets/img/coupon_bg.png") 0 0 /100% 100% no-repeat;
        span{
          font-size: 14px;
          width: 100%;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .get-coupon {
        width: 200px;
        height: 40px;
        background: #333333;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}

.good-detail {
  border-top: 1px solid #f0f0f0;
  padding-top: 60px;
  margin-top: 60px;
  padding-bottom: 60px;

  .good-detail-title, .good-detail-validity {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 60px;
  }

  .good-detail-validity {
    margin-bottom: 0px;
    margin-top: 20px;
  }

  .good-editor {
    line-height: 1.5;
  }
}

.distribution-shared {
  margin-top: 58px;
  padding-bottom: 58px;
  display: flex;
  align-items: center;

  p {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }

  .shareImg {
    width: 100px;
    height: 100px;
  }
}

///deep/ .coupon-list {
//  .coupon-item {
//    width: 310px;
//  }
//}
.good-editor {
  line-height: 1.3;
}
</style>
